export const getDataFromLS = (key) => {
  try {
    const value = localStorage.getItem(key)
    return value ? JSON.parse(value) : null
  } catch (e) {
    console.warn('localStorage недоступен или повреждён:', e)
    return null
  }
}

export const saveDataToLS = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.warn('Не удалось записать в localStorage:', e)
  }
}

export const getGeojson = (array) => {
  return {
    type: 'FeatureCollection',
    features: array.map((item) => ({
      type: 'Feature',
      properties: {
        title: item.num || `Без имени (${item.id})`,
        id: item.id
      },
      geometry: {
        type: 'Point',
        coordinates: [item.y, item.x]
      }
    }))
  }
}

export function splitString(str) {
  if (!str) return

  return str.split(/(\d+)/).filter((x) => x !== '')
}

export const filterData = (list, filters) => {
  if (!list?.length) return []

  const filtersValues = filters.map((f) => ({
    id: f.id,
    ids: f.filterValues.filter((e) => e.value).map((e) => e.id)
  }))

  return list.filter((e) => {
    return filtersValues.every((f) => {
      return f.ids.includes(e[f.id])
    })
  })
}

export const getAssetsSrc = (path) => {
  // path example - 'assets/images/logo/soilbox_logo.png'
  return new URL(`../${path}`, import.meta.url).href
}
